import app from "./app";

/**
 * Fetches the siting config for a given id of a sitting scenario.
 *
 * @param {Number} id - The id of the scenario
 * @returns {Promise}
 */
export async function getSitingScenarioConfigs(id) {
  if (id !== undefined) {
    const res = await app.get("/siting/config/" + id + "/", {});
    return res.data;
  }
}

export async function getSitingModels() {
  const res = await app.get("/siting/models/list_available/", {});
  return res.data;
}

export async function getSitingModelParameters(modelName, projectId) {
  if (modelName === undefined) return;

  const endpoint =
    projectId !== undefined
      ? `/siting/models/list_parameters/${modelName}/${projectId}/`
      : `/siting/models/list_parameters/${modelName}/`;

  const res = await app.get(endpoint, {});
  return res.data;
}

export async function patchSitingScenarioConfigs(id, data) {
  if (id !== undefined) {
    const res = await app.patch("/siting/config/" + id + "/", data);
    return res.data;
  }
}

export async function getSite(id) {
  if (id) {
    const res = await app.get("/siting/scenario-sites/" + id + "/", {});
    return res.data;
  } else {
    const res_1 = await app.get("/siting/scenario-sites/", {});
    return res_1.data;
  }
}

export async function getSitesByScenario(scenarioId) {
  if (scenarioId) {
    const res = await app.get(
      `/siting/scenario-sites/?scenario=${scenarioId}`,
      {}
    );
    return res.data;
  }
}

export async function getAllSitesByScenario(scenarioId) {
  if (scenarioId) {
    let allResults = [];
    let nextUrl = `/siting/scenario-sites/?scenario=${scenarioId}`;

    // Fetch all pages
    while (nextUrl) {
      const res = await app.get(nextUrl, {});
      const data = res.data;

      // Add results from current page
      if (data.results && Array.isArray(data.results)) {
        allResults = allResults.concat(data.results);
      }

      // Check if there's a next page
      nextUrl = data.next;
    }

    return allResults;
  }
}

export async function getSitesByProject(projectId) {
  if (projectId) {
    const res = await app.get(
      `/siting/scenario-sites/?project=${projectId}`,
      {}
    );
    return res.data;
  }
}

export async function getAllSitesByProject(projectId) {
  if (projectId) {
    let allResults = [];
    let nextUrl = `/siting/scenario-sites/?project=${projectId}`;

    // Fetch all pages
    while (nextUrl) {
      const res = await app.get(nextUrl, {});
      const data = res.data;

      // Add results from current page
      if (data.results && Array.isArray(data.results)) {
        allResults = allResults.concat(data.results);
      }

      // Check if there's a next page
      nextUrl = data.next;
    }

    return allResults;
  }
}

export async function deleteSite(id) {
  const res = await app.delete("/siting/scenario-sites/" + id + "/", {});
  return res.data;
}

export async function modifySite(id, data) {
  const res = await app.patch("/siting/scenario-sites/" + id + "/", data);
  return res.data;
}

/**
 * Uploads a sites file for a given project.
 * Expects a JSON body like: { fpath: "sites.gpkg" }
 *
 * @param {Number} projectId - The project id to upload the sites file for
 * @param {Object} data - The request payload (e.g. { fpath: 'sites.gpkg' })
 * @returns {Promise}
 */
export async function uploadSitesFile(scenarioId, data) {
  if (scenarioId === undefined) return;
  const res = await app.post(`/siting/upload/sites-file/${scenarioId}/`, data);
  return res.data;
}
